export default __webpack_public_path__ + "static/media/michelle-pic.24040043.png";